import {createStyles, makeStyles} from '@material-ui/core';
import clsx from 'clsx';
import {useTranslation} from 'react-i18next';
import {showDataPrivacyTab, showLegalNoticeTab, showProviderTab,} from '../../utility/DialogHelper';
import {Link} from 'react-router-dom';

// Styling
const useStyles = makeStyles(() =>
    createStyles({
        verticalLine: {
            marginTop: '48px',
            marginBottom: '24px',
            width: '100%',
            backgroundColor: '#333333',
            color: '#333333',
            borderWidth: 0,
            height: '1px',
        },
        linkText: {
            color: '#bfbfbf',
            fontSize: 'small',
            marginRight: '36px',
            marginBottom: '24px',
        },
        container: {
            height: '80px',
            textAlign: 'center',
        },
        floatingButton: {
            position: 'fixed',
            bottom: '25px', // Increased from 20px to 50px for "a little bit above"
            right: '20px',
            backgroundColor: '#2196F3', // Blue color
            color: 'white', // Text color for contrast
            border: 'none', // Remove border for a cleaner look
            borderRadius: '50px', // Keep it rounded, you can adjust this value
            padding: '12px 24px', // Slightly more padding
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)', // Slightly stronger shadow
            zIndex: 1000,
            cursor: 'pointer',
            textDecoration: 'none',
            fontWeight: 'bold',
            fontSize: '1rem', // Make the font size a bit larger
            '&:hover': {
                backgroundColor: '#1976D2', // Darker blue on hover
            },
            transition: 'background-color 0.3s ease', // Smooth transition for hover effect
        },
    })
);

/**
 * Main page (landing page or home page) component.
 *
 * @returns
 */

export function Footer() {
    const classes = useStyles();
    const {t} = useTranslation();

    return (
        <>
            <hr className={clsx(classes.verticalLine)}></hr>
            <div className='wb-grid-container'>
                <div className={clsx('wb-grid-row', classes.container)}>
                    <div className='wb-grid-col-mq1-12'>
                        <a
                            onClick={showProviderTab}
                            className={clsx(
                                'wb-link wb-link--standalone showForSmartphone',
                                classes.linkText
                            )}
                        >
                            {t('Provider')}
                        </a>{' '}
                        <a
                            onClick={showProviderTab}
                            className={clsx(
                                'wb-link wb-link--standalone hideForSmartphone',
                                classes.linkText
                            )}
                        >
                            {t('ReservedRights')}
                        </a>{' '}
                        <a
                            onClick={showLegalNoticeTab}
                            className={clsx('wb-link wb-link--standalone', classes.linkText)}
                        >
                            {t('LegalNotice')}
                        </a>{' '}
                        {/*<a*/}
                        {/*  onClick={showSettingsTab}*/}
                        {/*  className={clsx('wb-link wb-link--standalone', classes.linkText)}*/}
                        {/*>*/}
                        {/*  {t('Settings')}*/}
                        {/*</a>{' '}*/}
                        <a
                            onClick={showDataPrivacyTab}
                            className={clsx('wb-link wb-link--standalone', classes.linkText)}
                        >
                            {t('PrivacyStatement')}
                        </a>{' '}
                        <Link
                            className={clsx('wb-link wb-link--standalone', classes.linkText)}
                            to={'/contact'}
                        >
                            {t('Contact')}
                        </Link>{' '}
                    </div>
                </div>
            </div>
            <Link to={'/oil-finder'} className={classes.floatingButton}>
                {t('OilFinder')}
            </Link>
        </>
    );
}
